import { Contact } from './phone_texts';

interface ContactsProps {
    contacts: { name: Contact; lastMessage: string }[];
    selectContact: (contact: Contact) => void;
    enabled: boolean;
}

function Contacts(props: ContactsProps) {
    const { contacts, selectContact, enabled } = props;

    return (
        <div className="phone-contacts">
            <div className="header">Messages</div>
            {contacts.map((contact) => (
                <div
                    key={contact.name}
                    className="phone-contact"
                    onClick={
                        enabled
                            ? (): void => selectContact(contact.name)
                            : undefined
                    }
                >
                    <div className="name">{contact.name}</div>
                    <div className="last-message">{contact.lastMessage}</div>
                </div>
            ))}
        </div>
    );
}

export default Contacts;
